import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment-timezone';

import SearchResult from '../SearchResult';

import './FavoriteVenueCard.scss';

const FavoriteVenueCard = ({
  compact,
  venue,
  isMobile,
  event,
  selectedDate,
  showBorder,
  onFavoriteClick,
}) => {
  const handleFavoriteClick = (response) => {
    onFavoriteClick(response);
  };

  return (
    <div className="FavoriteVenueCard">
      <div
        className={cx('FavoriteVenueCard__greyedOut')}
      />
      <SearchResult
        canFavorite
        venue={venue}
        showSlots={false}
        isMobile={isMobile}
        onFavoriteClick={handleFavoriteClick}
        event={event}
        selectedDate={selectedDate}
        compact={compact}
        showBorder={showBorder}
      />
    </div>
  );
};

FavoriteVenueCard.propTypes = {
  isMobile: PropTypes.bool,
  compact: PropTypes.bool,
  event: PropTypes.func.isRequired,
  onFavoriteClick: PropTypes.func,
  showBorder: PropTypes.bool,
  venue: PropTypes.shape({
    collections: PropTypes.arrayOf(PropTypes.object),
    favorite: PropTypes.bool,
    images: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    priceRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rating: PropTypes.number,
    reopen: PropTypes.shape({
      date: PropTypes.string,
    }),
  }).isRequired,
  selectedDate: PropTypes.string,
};

FavoriteVenueCard.defaultProps = {
  isMobile: false,
  compact: false,
  showBorder: true,
  onFavoriteClick: () => { },
  selectedDate: moment().format('YYYY-MM-DD'),
};

FavoriteVenueCard.displayName = 'FavoriteVenueCard';
export default FavoriteVenueCard;
